module.exports = __webpack_public_path__ + "assets/img/serviceLogo.35a42e75.png";